import { render, staticRenderFns } from "./DefaultSettings.vue?vue&type=template&id=5ee5fa62"
import script from "./DefaultSettings.vue?vue&type=script&lang=js"
export * from "./DefaultSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports